export default __webpack_public_path__ + "static/media/flow3En.b6f61b67.jpg";